
import { QueryDispatcher } from 'SourceUtil/Request';
import BrowserDatabase from "SourceUtil/BrowserDatabase/BrowserDatabase";
import { showNotification } from 'SourceStore/Notification/Notification.action';
import { CUSTOM_ATTRIBUTES as fields } from '../../utils/config/index';
import CustomAttributeQuery from '../../query/CustomAttribute.query';
import MyAccountQuery from 'SourceQuery/MyAccount.query';
import { fetchQuery } from 'SourceUtil/Request';
import { getCustomerAttributeData, updateIsLoading, getCustomerAttributeFields } from './EnhacnedRegistration.action';

export class EnhacnedRegistrationDispatcher extends QueryDispatcher {

    onSuccess({ customer }, dispatch) {

        if (customer) {
            this.setCustomerData(customer, dispatch)
        }
    }

    getCustomerAttributeFields = (dispatch) => {
        const query = CustomAttributeQuery.getCustomerAttribute(fields);
        
        return fetchQuery(query).then(
            ({ customAttributeMetadata }) =>  dispatch(getCustomerAttributeFields(customAttributeMetadata)),
            (error) => {
                dispatch(showNotification('error', __(error ? error[0].message : 'unable to get customer data fiels!')));
            }
        );
    }

    setCustomerData = (customer, dispatch) => {
        const { custom_attributes = {} } = customer;
        let customData = {};
        if (custom_attributes && Object.values(custom_attributes).length > 0) {
            custom_attributes.map(({ attribute_code, value }) => {
                if (attribute_code === 'skin_concerns'
                    || attribute_code === 'favorite_stores'
                    || attribute_code === 'favorite_brands') {
                    const isArray = value.indexOf(',');
                    if (isArray !== -1) {
                        const toArray = value.split(',').map((val) => val);
                        customData[attribute_code] = {
                            value: toArray
                        };
                    } else {
                        customData[attribute_code] = {
                            value: [value]
                        };
                    }
                } else {
                    customData[attribute_code] = {
                        value
                    };
                }
            });
        }

        dispatch(getCustomerAttributeData(customData));
        updateIsLoading(false);
    }

    onError(error, dispatch) {
        dispatch(showNotification('error', __('Error fetching Customer Information!'), error));
    }

    prepareRequest(dispatch) {
        updateIsLoading(true);
        return [
            MyAccountQuery.getCustomerQuery()
        ];
    }

}

export default new EnhacnedRegistrationDispatcher()
